export const AUTH_TOKEN_NAME = 'authToken'
export const REFRESH_TOKEN_NAME = 'refreshToken'
export const STAY_LOGGED_IN_NAME = 'stayLoggedIn'
export const ACCOUNT_ID_NAME = 'accountId'
